export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=6018cbf6"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Highwaycompany/index.vue?vue&type=template&id=6018cbf6
// module id = 2732
// module chunks = 31